import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase, resolveNextDestination } from "@/lib/supabase";

export default function CallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("جارٍ إتمام تسجيل الدخول...");

  useEffect(() => {
    const code = searchParams.get("code");
    const next = searchParams.get("next");

    if (!code) {
      navigate("/provider/settlements", { replace: true });
      return;
    }

    supabase.auth
      .exchangeCodeForSession(code)
      .then(({ error }) => {
        if (error) {
          setMessage("تعذر إتمام تسجيل الدخول — الرابط غير صالح أو منتهي.");
          setTimeout(() => navigate("/auth/login", { replace: true }), 2500);
          return;
        }
        navigate(resolveNextDestination(next), { replace: true });
      })
      .catch(() => {
        navigate("/auth/login", { replace: true });
      });
  }, [navigate, searchParams]);

  return (
    <div dir="rtl" className="flex h-screen w-full flex-col items-center justify-center gap-3 bg-[#F0FDFD]">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#E4F5F5] border-t-[#00AAB7]" />
      <p className="text-sm text-ghasla-text-secondary">{message}</p>
    </div>
  );
}